<section class="w-full font-display p-4 sm:p-6">
  <div class="w-full flex flex-col space-y-4 justify-center items-center">
    <span class="text-xl sm:text-2xl font-semibold text-center">{{
      data?.title ?? "-"
    }}</span>
    <span class="text-[#767676] text-center w-full sm:w-4/5">{{
      data?.message ?? "-"
    }}</span>
    <i class="fa-regular fa-circle-question text-5xl sm:text-6xl text-[#F68E17]"></i>
  </div>
  <div class="flex flex-col sm:flex-row w-full items-center justify-center gap-3 sm:gap-4 mt-8">
    <button
      (click)="closeDialog(true)"
      class="w-full sm:w-40 h-12 rounded-lg bg-[#3DB474] text-white flex items-center justify-center space-x-2"
    >
      Submit
    </button>
    <button
      (click)="closeDialog(false)"
      class="w-full sm:w-40 h-12 rounded-lg bg-[#FF6A65] text-white flex items-center justify-center space-x-2"
    >
      Cancel
    </button>
  </div>
</section>
